import { Grid } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ComponentPageHeader from '../../Common/PageHeader/ComponentPageHeader';
import DataTable from '../../Common/DataTable';
import { HazardAnalysisData } from './utils/types';
import { RootState } from '../../redux/rootState';
import { setLoader } from '../../redux/loaderSlice';
import { exportToExcelData } from '../../Common/PageHeader/helper';
import { getHazardAnalysisData } from './redux/hazardAnalysisSlice';

function ScreenHazardAnalysis() {
  const Navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState('');
  const { hazardAnalysisListData, TotalRecords, isLoading } = useSelector((state: RootState) => state.hazardAnalysisReducer);

  const handleData = () => {
    const params = {
      page,
      rowsPerPage,
      searchQuery,
    };
    dispatch(getHazardAnalysisData(params));
  };

  useEffect(() => {
    handleData();
  }, []);

  const data: HazardAnalysisData[] = useMemo(() => {
    if (hazardAnalysisListData?.length > 0) {
      const transformedData = hazardAnalysisListData?.map((item, index) => ({
        sn: index,
        jobOrder: item?.JobOrder,
        action: 'edit',
        id: item?.JobOrder,
      }));
      return transformedData;
    }
    return [];
  }, [hazardAnalysisListData]);

  const excelData = useMemo(() => hazardAnalysisListData?.map((item) => {
    const transformedDataItem = {
      jobOrder: item?.JobOrder,
    };
    return transformedDataItem;
  }), [hazardAnalysisListData]);

  const columns = useMemo(
    () => [
      // { key: 'sn', label: 'SN' },
      { key: 'action', label: 'Action' },
      { key: 'jobOrder', label: 'Job Order' },
    ],
    [],
  );

  const handleEdit = (id: string) => {
    Navigate(`${id}`);
  };

  const downloadExcel = () => {
    exportToExcelData(
      {
        data: excelData,
      },
      'HAZARD_ANALYSIS',
    );
  };

  useEffect(() => {
    dispatch(setLoader(isLoading));
  }, [isLoading]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={12} md={12}>
        <ComponentPageHeader subHeading="HAZARD ANALYSIS" downloadExcel={downloadExcel} />
      </Grid>
      <Grid item xs={12} sm={12} md={12} className="dataTableCustomMargin">
        <DataTable<HazardAnalysisData>
          data={data}
          columns={columns}
          totalRecords={TotalRecords}
          page={page}
          setPage={setPage}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          handleData={handleData}
          handleEdit={handleEdit}
        />
      </Grid>
    </Grid>
  );
}

export default ScreenHazardAnalysis;
